export const setSearchParam = (state, {skill, location, job_type, last_updated, search_category}) => {
    state.search.skill = skill;
    state.search.location = location;
    state.search.job_type = job_type;
    state.search.last_updated = last_updated;
    state.search.search_category = search_category;
} 